<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="rp" class="block text-sm font-medium text-gray-700">RP <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="number" id="rp" :value="loadData.rp || selectedData.rp"
        @change="(newRP) => $emit('updateValues', { 'rp': customUpdateValueData('rp', newRP.target.value) })"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="fecha" class="block text-sm font-medium text-gray-700">Fecha <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="date" :disabled="view === ''" id="fecha" :value="loadData.fecha || selectedData.fecha"
        @change="(newFecha) => $emit('updateValues', { 'fecha': customUpdateValueData('fecha', newFecha.target.value) })"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="id_rubro" class="block text-sm font-medium text-gray-700">Rubro <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <select id="id_rubro" :disabled="view === ''" :value="loadData.id_rubro || selectedData.id_rubro"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        @change="(newRubroId) => $emit('updateValues', { 'id_rubro': customUpdateValueData('id_rubro', newRubroId.target.value) })">
        <option value="" selected>Seleccione un rubro...</option>
        <option v-for="(rubro, index) of collectionRubros" :key="'B' + index" :value="rubro.id">{{
          `${rubro.rubro} - ${rubro.nombre}`
        }}
        </option>
      </select>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="id_macro_fuente" class="block text-sm font-medium text-gray-700">Fuente Macro <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <select id="id_macro_fuente" :disabled="view === ''"
        :value="selectedFuenteMacro || selectedData.fuenteConcreta.id_fuente_macro"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        @change="(newFuenteMacroId) => { $emit('updateFuenteMacro', newFuenteMacroId.target.value); $emit('updateValues', { 'id_codigo_fuente': '' }) }">
        <option value="" selected>Seleccione una fuente...</option>
        <option v-for="(fuenteMacro, index) of collectionFuenteMacro" :key="'B' + index" :value="fuenteMacro.id">{{
          fuenteMacro.nombre
        }}
        </option>
      </select>
    </div>
    <div v-if="selectedFuenteMacro || selectedData.id_codigo_fuente" class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="id_codigo_fuente" class="block text-sm font-medium text-gray-700">Fuente <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <select id="id_codigo_fuente" :disabled="view === ''"
        :value="loadData.id_codigo_fuente || selectedData.id_codigo_fuente"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        @change="(newFuenteId) => $emit('updateValues', { 'id_codigo_fuente': customUpdateValueData('id_codigo_fuente', newFuenteId.target.value) })">
        <option value="" selected>Seleccione una fuente...</option>
        <option v-for="(fuente, index) of collectionFuenteConcreta" :key="'B' + index" :value="fuente.id">
          {{ `${fuente.codigo} - ${fuente.nombre}` }}
        </option>
      </select>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="id_contrato" class="block text-sm font-medium text-gray-700">Contrato <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <select id="id_contrato" :value="loadData.id_contrato || selectedData.id_contrato"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        @change="(newContratoId) => $emit('updateValues', { 'id_contrato': customUpdateValueData('id_contrato', newContratoId.target.value) })">
        <option value="" selected>Seleccione un contrato...</option>
        <option v-for="(contrato, index) of collectionContratos" :key="'B' + index" :value="contrato.id">{{
          `${contrato.codigo} - ${contrato.concepto}`
        }}
        </option>
      </select>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="id_beneficiario" class="block text-sm font-medium text-gray-700">Beneficiario <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <select id="id_beneficiario" :disabled="view === ''" :value="loadData.id_beneficiario || selectedData.id_beneficiario"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        @change="(newBeneficiarioId) => $emit('updateValues', { 'id_beneficiario': customUpdateValueData('id_beneficiario', newBeneficiarioId.target.value) })">
        <option value="" selected>Seleccione un beneficiario...</option>
        <option v-for="(beneficiario, index) of collectionBeneficiarios" :key="'B' + index" :value="beneficiario.id">{{
          beneficiario.nombre
        }}
        </option>
      </select>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="valor" class="block text-sm font-medium text-gray-700">Valor <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700 '">(*)</span></label>
      <input type="text" :disabled="view === 'actualizar'" id="valor" :value="formattedValue !== '' ? formattedValue : (loadData.valor || selectedData.valor || valor)"
        @input="updateValue($event.target.value)"
        @change="(newValor) => $emit('updateValues', { 'valor': customUpdateValueData('valor', newValor.target.value) })"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>

    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="identificador_informe" class="block text-sm font-medium text-gray-700">Vigencia del Informe del Pasivo</label>
      <input type="text" id="identificador_informe" maxlength="255"
        :value="loadData.identificador_informe || selectedData.identificador_informe"
        @change="(newIdentificador) => $emit('updateValues', { 'identificador_informe': customUpdateValueData('identificador_informe', newIdentificador.target.value) })"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>

    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="id_macro_ejecutor" class="block text-sm font-medium text-gray-700">Macro Ejecutor <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <select id="id_macro_ejecutor" :disabled="view === ''"
        :value="selectedMacroEjecutor || selectedData.secretariaEjecutora.id_macro_ejecutor"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        @change="(newMacroEjecutorId) => { $emit('updateMacroEjecutor', newMacroEjecutorId.target.value); $emit('updateValues', { 'id_secretaria_ejecutora': '' }) }">
        <option value="" selected>Seleccione un macro ejecutor...</option>
        <option v-for="(macroEjecutor, index) of collectionMacroEjecutor" :key="'B' + index" :value="macroEjecutor.id">{{
          macroEjecutor.nombre
        }}
        </option>
      </select>
    </div>
    <div v-if="selectedMacroEjecutor || selectedData.id_secretaria_ejecutora"
      class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="id_secretaria_ejecutora" class="block text-sm font-medium text-gray-700">Ordenador del Gasto <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <select id="id_secretaria_ejecutora" :disabled="view === ''"
        :value="loadData.id_secretaria_ejecutora || selectedData.id_secretaria_ejecutora"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        @change="(newSecretariaEjecutoraId) => $emit('updateValues', { 'id_secretaria_ejecutora': customUpdateValueData('id_secretaria_ejecutora', newSecretariaEjecutoraId.target.value) })">
        <option value="" selected>Seleccione un ordenador del gasto...</option>
        <option v-for="(secretariaEjecutora, index) of collectionSecretariaEjecutora" :key="'B' + index"
          :value="secretariaEjecutora.id">{{
            secretariaEjecutora.nombre
          }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
import { separateNumberByCommaInput } from '@/common/constants';
import { computed, ref } from 'vue';


/**
 * Componente de Vue.js para crear y actualizar provisiones
 * @name ProvisionesCrearActualizarComponent
 * @module ProvisionesCrearActualizarComponent
 */
export default {
  name: 'PasivoExigibleCrearActualizarComponent',
  props: ['view', 'paginate', 'selectedData', 'loadData', 'entity', 'listApi',
    'queries', 'customListData', 'authToken', 'collectionFuenteConcreta', 'collectionBeneficiarios',
    'collectionContratos', 'collectionFuenteMacro', 'selectedFuenteMacro',
    'collectionMacroEjecutor', 'selectedMacroEjecutor',
    'customUpdateLoadData', 'collectionRubros', 'collectionTipoCAP',
    'collectionSecretariaEjecutora', 'customUpdateValueData'],
  emits: ["updateValues", "customSaveData"],

  async setup(props, { emit }) {

    /**
     * Función asincrónica que guarda los datos en la API.
     * @async
     * @function
     * @name customSaveData
     * @returns {Promise<void>} - Promesa que no devuelve ningún valor.
     */

    const valor = ref('');

    const formattedValue = computed(() => {
      if (valor.value !== '') {
        return separateNumberByCommaInput(valor.value);
      } else if (props.loadData.valor) {
        return separateNumberByCommaInput(props.loadData.valor);
      } else {
        return separateNumberByCommaInput(props.selectedData.valor);
      }
    });
    const updateValue = (newValue) => {
      valor.value = newValue.replace(/,/g,'');
      console.log(valor.value);
      emit('updateValues', { valor: valor.value });
    };

    return{
      formattedValue,
      updateValue
    }
  },
}

</script>
<style scoped>.readonly-input {
  background-color: #f2f2f2;
}</style>